import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    List,
    ListItem,
    ListItemText
} from 'minimal-ui';

const ConfirmSwapDialog = ({ open, onClose, onConfirm, swapData, isSubmitting }) => {
    return (
        <Dialog
            open={open}
            onClose={() => !isSubmitting && onClose()}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                Confirm Product Swap
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="text.secondary" mb={2}>
                    You are replacing the following promotional products. Do you want to proceed?
                </Typography>
                
                {swapData.removed.length > 0 && (
                    <Box mb={2}>
                        <Typography variant="subtitle2" fontWeight={600} mb={1}>
                            Removed Products:
                        </Typography>
                        <List dense>
                            {swapData.removed.map((product, index) => (
                                <ListItem key={index} sx={{ px: 0 }}>
                                    <ListItemText
                                        primary={product.product_name}
                                        secondary={`Code: ${product.product_code} | Type: ${product.product_type}`}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                )}

                {swapData.added.length > 0 && (
                    <Box>
                        <Typography variant="subtitle2" fontWeight={600} mb={1}>
                            New Products:
                        </Typography>
                        <List dense>
                            {swapData.added.map((product, index) => (
                                <ListItem key={index} sx={{ px: 0 }}>
                                    <ListItemText
                                        primary={product.product_name}
                                        secondary={`Code: ${product.product_code} | Type: ${product.product_type}`}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    disabled={isSubmitting}
                >
                    Cancel
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    color="error"
                    disabled={isSubmitting}
                    sx={{
                        '&.MuiButton-root': {
                            backgroundColor: '#E27172',
                            color: 'white',
                        }
                    }}
                >
                    {isSubmitting ? 'Processing...' : 'Confirm'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmSwapDialog;

